/**
 * Embroidery Canvas Preview - 完成版
 * 機能: 生地テクスチャ背景 / 刺繍テキスト / 干支アイコン / 末尾・頭部記号
 * フォント: Kapakana / TASA Orbiter / Kosugi Maru
 */

const EmbroideryPreview = (function () {

  const CONFIG = {
    canvasSize:       420,
    iconSize:         140,
    seasonalIconSize: 175,  // ★ シーズナルヒポアイコン専用サイズ
    seasonalIconKeys: ['Halloween'],  // ★ 今後追加時はここに追加するだけ
    iconMarginBottom:  6,
    symbolSize:        40,
    symbolGap:          6,
    symbolTextGap:      4,  // ★ テキストと絵文字の間の余白
    symbolTextGapOverrides: [   // ★ 追加：条件付き余白
      { fonts: ['Kapakana'], lastChars: ['S', 'N'], gap: 20 },
    ],
    defaultFont:      "'Kapakana', cursive",
    defaultFontSize:   72,
    defaultTextColor: '#FFFFFF',
    defaultBgColor:   'NAVY',
    stitchDensity:      3,
    stitchLength:       4,
    stitchVariance:     1.5,
    grainOpacity:       0.18,
    shadowBlur:         2,
    shadowOffset:       1.5,
    // bold指定しないフォント（Regularのみのフォント）
    noBoldFonts: ['Kosugi Maru', 'Kapakana', 'TASA Orbiter'],
  };

  const ICON_MAP = {
    '子（ねずみ）': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_eto-rat.svg?v=1790070824',
    '丑（うし）':   'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_eto-ox.svg?v=1790070824',
    '寅（とら）':   'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_eto-tiger.svg?v=1790070824',
    '卯（うさぎ）': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_eto-rabbit.svg?v=1790070824',
    '辰（たつ）':   'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_eto-dragon.svg?v=1790070824',
    '巳（み）':     'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_eto-snake.svg?v=1790070824',
    '午（うま）':    'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_eto-horse.svg?v=1790070824',
    '未（ひつじ）':  'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_eto-sheep.svg?v=1790070824',
    '申（さる）':    'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_eto-monkey.svg?v=1790070824',
    '酉（とり）':    'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_eto-rooster.svg?v=1790070824',
    '戌（いぬ）':    'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_eto-dog.svg?v=1790070824',
    '亥（いのしし）': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_eto-boar.svg?v=1790070824',
    'おひつじ座（3/21〜4/19）': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_zodiac-aries.svg?v=1790070850',
    'おうし座（4/20〜5/20）':   'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_zodiac-taurus.svg?v=1790070850',
    'ふたご座（5/21〜6/21）':   'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_zodiac-gemini.svg?v=1790070850',
    'かに座（6/22〜7/22）':     'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_zodiac-cancer.svg?v=1790070850',
    'しし座（7/23〜8/22）':     'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_zodiac-leo.svg?v=1790070850',
    'おとめ座（8/23〜9/22）':   'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_zodiac-virgo.svg?v=1790070850',
    'てんびん座（9/23〜10/23）': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_zodiac-libra.svg?v=1790070850',
    'さそり座（10/24〜11/22）':  'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_zodiac-scorpio.svg?v=1790070850',
    'いて座（11/23〜12/21）':   'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_zodiac-sagittarius.svg?v=1790070850',
    'やぎ座（12/22〜1/19）':    'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_zodiac-capricorn.svg?v=1790070850',
    'みずがめ座（1/20〜2/18）':  'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_zodiac-aquarius.svg?v=1790070850',
    'うお座（2/19〜3/20）':     'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_zodiac-pisces.svg?v=1790070850',
    'A': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_letter-a.svg?v=1790070824',
    'B': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_letter-b.svg',
    'C': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_letter-c.svg',
    'D': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_letter-d.svg',
    'E': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_letter-e.svg',
    'F': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_letter-f.svg',
    'G': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_letter-g.svg',
    'H': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_letter-h.svg',
    'I': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_letter-i.svg',
    'J': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_letter-j.svg',
    'K': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_letter-k.svg',
    'L': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_letter-l.svg',
    'M': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_letter-m.svg',
    'N': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_letter-n.svg',
    'O': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_letter-o.svg',
    'P': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_letter-p.svg',
    'Q': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_letter-q.svg',
    'R': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_letter-r.svg',
    'S': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_letter-s.svg',
    'T': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_letter-t.svg',
    'U': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_letter-u.svg',
    'V': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_letter-v.svg',
    'W': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_letter-w.svg',
    'X': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_letter-x.svg',
    'Y': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_letter-y.svg',
    'Z': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_letter-z.svg',
    'Halloween': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_seasonal-halloween.svg?v=1790070824',
    'Christmas': 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_seasonal-xmas.svg',
  };

  const SYMBOL_MAP = [
    { id: 'heart',   label: 'ハート',      url: 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_symbol-heart.svg' },
    { id: 'palm',    label: 'ヤシ',       url: 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_symbol-palmtree.svg' },
    { id: 'flower',  label: 'フラワー',    url: 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_symbol-flower.svg' },
    { id: 'moon',    label: 'ムーン',     url: 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_symbol-moon.svg' },
    { id: 'clover',  label: 'クローバー',  url: 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_symbol-clover.svg' },
    { id: 'rocket',  label: 'ロケット',    url: 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_symbol-rocket.svg' },
    { id: 'dino',    label: 'ディノ',     url: 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_symbol-dino.svg' },
    { id: 'star',    label: 'スター',     url: 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_symbol-star.svg' },
    { id: 'rainbow', label: 'レインボウ',  url: 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_symbol-rainbow.svg' },
    { id: 'cherry',  label: 'チェリー',    url: 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_symbol-cherry.svg' },
    { id: 'bone',    label: 'ボーン',     url: 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_symbol-bone.svg' },
    { id: 'hippo',   label: 'ヒポ',       url: 'https://cdn.shopify.com/s/files/1/0065/9416/6902/files/icon_emb_symbol-hippo.svg' },
  ];

  const BG_COLORS = [
    { id: 'ORANGE',            label: 'ORANGE',                 hex: '#e64503', textureStyle: 'dark'  },
    { id: 'BLUE',              label: 'BLUE',                  hex: '#00317e', textureStyle: 'dark'  },
    { id: 'WHITE',             label: 'WHITE',                 hex: '#F8F6F2', textureStyle: 'light' },
    { id: 'CASSIS',           label: 'CASSIS',                  hex: '#811346', textureStyle: 'dark' },
    { id: 'PISTACHIO',         label: 'PISTACHIO',               hex: '#526027', textureStyle: 'dark' },
    { id: 'NAVY',              label: 'NAVY',                 hex: '#0f203d', textureStyle: 'dark'  },
    { id: 'GOLD',              label: 'GOLD',                 hex: '#b09012', textureStyle: 'dark'  },
    { id: 'ROSE',              label: 'ROSE',                   hex: '#eb426e', textureStyle: 'dark'  },
    { id: 'CARIBBEAN',         label: 'CARIBBEAN',               hex: '#00B4CC', textureStyle: 'dark'  },
    { id: 'BRITISHSHORTHAIR',  label: 'BRITISHSHORTHAIR',  hex: '#606269', textureStyle: 'light'  },
    { id: 'MATADOR',           label: 'MATADOR',               hex: '#c81a1c', textureStyle: 'dark'  },
  ];

  const FONT_SIZE_MAP = {
    'Kapakana':     58,
    'TASA Orbiter': 46,
    'Kosugi Maru':  40,
  };

  let canvas, ctx, offCanvas, offCtx;
  let currentBgId = CONFIG.defaultBgColor;
  const _imgCache = {};

  // ============================================================
  // フォント宣言ヘルパー（boldを使うか判定）
  // ============================================================
  function _fontDecl(font, fontSize) {
    var weight = 'normal';
    if (font.includes('Kapakana'))     weight = 'bold';
    if (font.includes('Kosugi Maru'))  weight = '600';
    if (font.includes('TASA Orbiter')) weight = 'normal';
    return weight + ' ' + fontSize + 'px ' + font;
  }

  // ============================================================
  // 刺繍プレビューの表示/非表示制御
  // ============================================================
  var EMBROIDERY_OPTION_NAME = 'properties[刺繍入れ（1アイテムにつき¥770〜）]';
  var EMBROIDERY_SHOW_VALUE  = '希望する';
  var previewWrap = document.getElementById('embroidery-preview-wrap');

  function updatePreviewVisibility() {
    var checked = document.querySelector(
      '[name="' + EMBROIDERY_OPTION_NAME + '"]:checked'
    );
    var shouldShow = checked && checked.value === EMBROIDERY_SHOW_VALUE;

    // embroidery-preview-wrap と embroidery-preview-col の両方を制御
    if (previewWrap) {
      previewWrap.style.display = shouldShow ? '' : 'none';
    }

    var previewCol = document.getElementById('embroidery-preview-col');
    if (previewCol) {
      previewCol.style.display = shouldShow ? '' : 'none';
      if (shouldShow) {
        setTimeout(function() {
          previewCol.scrollTop = 0;
        }, 50);
      }
    }

    if (shouldShow) {
      if (typeof window.updatePreview === 'function') {
        window.updatePreview();
      }
    }

  }

  // 初期状態を設定
  updatePreviewVisibility();

  // 変更を監視（既存のchangeイベントに統合）
  document.addEventListener('change', function (e) {
    var name = e.target.getAttribute('name');
    if (!name || !name.startsWith('properties[')) return;

    // 刺繍入れオプションの変更時は表示切り替えを優先
    if (name === EMBROIDERY_OPTION_NAME) {
      updatePreviewVisibility();
      return;
    }

    updatePreview();
  });

  // ============================================================
  // 初期化
  // ============================================================
  function init(containerId, onReady) {
    const container = document.getElementById(containerId);
    if (!container) return;

    canvas = document.createElement('canvas');
    canvas.width  = CONFIG.canvasSize;
    canvas.height = CONFIG.canvasSize;
    canvas.style.cssText = 'border:1px solid #ddd; border-radius:4px; max-width:90; margin:0 auto; display:block;';
    container.appendChild(canvas);
    ctx = canvas.getContext('2d');

    offCanvas = document.createElement('canvas');
    offCanvas.width  = CONFIG.canvasSize;
    offCanvas.height = CONFIG.canvasSize;
    offCtx = offCanvas.getContext('2d');

    _drawPlaceholder();

    _warmupFonts().then(function () {
      if (typeof onReady === 'function') onReady();
    }).catch(function () {
      if (typeof onReady === 'function') onReady();
    });
  }

  // 全フォントを事前にロードしてグリフを展開する
  function _warmupFonts() {
    // 日本語の全文字種をカバーするサンプル文字列
    const sampleText = 'あいうえおアイウエオ一二三abcABC';

    const loads = [
      document.fonts.load("48px 'Kosugi Maru'", sampleText),
      document.fonts.load("64px 'Kapakana'",    sampleText),
      document.fonts.load("50px 'TASA Orbiter'", sampleText),
    ];

    return Promise.all(loads).then(function(results) {
      console.log('EmbroideryPreview: fonts warmed up', results.map(function(r){ return r.length; }));
    }).catch(function(e) {
      console.warn('EmbroideryPreview: font warmup failed', e);
    });
  }

  // ============================================================
  // 背景カラースウォッチUI
  // ============================================================
  function buildColorSwatches(containerId, onChange) {
    const container = document.getElementById(containerId);
    if (!container) return;
    container.innerHTML = '';
    container.style.cssText = 'display:flex; flex-wrap:wrap; gap:8px; margin-top:8px;';

    BG_COLORS.forEach(function (color) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.title = color.label;
      btn.dataset.colorId = color.id;
      btn.style.cssText = `
        width:32px; height:32px; border-radius:50%;
        background-color:${color.hex};
        border:3px solid transparent;
        cursor:pointer;
        transition:border-color 0.2s, transform 0.15s;
        box-shadow:0 1px 3px rgba(0,0,0,0.25);
      `;
      if (color.id === currentBgId) {
        btn.style.borderColor = '#333';
        btn.style.transform = 'scale(1.15)';
      }
      btn.addEventListener('click', function () {
        currentBgId = color.id;
        container.querySelectorAll('button').forEach(function (b) {
          b.style.borderColor = 'transparent';
          b.style.transform = 'scale(1)';
        });
        btn.style.borderColor = '#333';
        btn.style.transform = 'scale(1.15)';
        if (typeof onChange === 'function') onChange(color.id);
      });
      container.appendChild(btn);
    });
  }

  // ============================================================
  // メイン描画
  // ============================================================
  function render({
    text = '',
    font = CONFIG.defaultFont,
    textColor = CONFIG.defaultTextColor,
    bgColorId = null,
    iconKey = null,
    prefixSymbols = [],
    suffixSymbols = [],
    backgroundOnly = false
  } = {}) {
    if (!ctx) return;
    if (bgColorId) currentBgId = bgColorId;

    const bgDef = BG_COLORS.find(c => c.id === currentBgId)
      || BG_COLORS.find(c => c.id === 'NAVY');

    // 生地のみ表示：刺繍・絵文字・プレースホルダーは描画しない
    if (backgroundOnly) {
      ctx.clearRect(0, 0, CONFIG.canvasSize, CONFIG.canvasSize);
      _drawFabricBackground(bgDef);
      return;
    }

    const fontKey = Object.keys(FONT_SIZE_MAP).find(k => font.includes(k));
    const fontSize = fontKey ? FONT_SIZE_MAP[fontKey] : CONFIG.defaultFontSize;
    const iconUrl = iconKey ? ICON_MAP[iconKey] : null;

    if (iconUrl) {
      _loadImage(iconUrl, function (img) {
        _renderFrame({
          text, font, fontSize, textColor, bgDef,
          img, iconKey, prefixSymbols, suffixSymbols
        });
      });
    } else {
      _renderFrame({
        text, font, fontSize, textColor, bgDef,
        img: null, iconKey, prefixSymbols, suffixSymbols
      });
    }
  }

  // ============================================================
  // 実描画処理
  // ============================================================
  function _renderFrame({ text, font, fontSize, textColor, bgDef, img, iconKey, prefixSymbols, suffixSymbols }) {

    const W = CONFIG.canvasSize;
    const H = CONFIG.canvasSize;

    // マスク専用キャンバスを毎回クリーンに作成
    const maskCanvas = document.createElement('canvas');
    maskCanvas.width  = W;
    maskCanvas.height = H;
    const mCtx = maskCanvas.getContext('2d');
    mCtx.clearRect(0, 0, W, H);

    ctx.clearRect(0, 0, W, H);
    _drawFabricBackground(bgDef);

    const hasIcon    = !!img;
    const hasText    = !!text.trim();
    const hasPre     = prefixSymbols  && prefixSymbols.length  > 0;
    const hasSuf     = suffixSymbols  && suffixSymbols.length  > 0;

    if (!hasIcon && !hasText && !hasPre && !hasSuf) {
      _drawPlaceholderOnBg(bgDef);
      return;
    }

    // seasonalIconKeysに含まれる場合は専用サイズを使用
    const iconSize = (iconKey && CONFIG.seasonalIconKeys.indexOf(iconKey) !== -1)
      ? CONFIG.seasonalIconSize
      : CONFIG.iconSize;
    const iconMargin = CONFIG.iconMarginBottom;
    const symSize    = CONFIG.symbolSize;
    const symGap     = CONFIG.symbolGap;

    // テキスト幅計算
    let textWidth = 0;
    if (hasText) {
      offCtx.font = _fontDecl(font, fontSize);
      textWidth = offCtx.measureText(text).width;
    }

    const textSymGap = CONFIG.symbolTextGap;

    // ★ フォント×末尾文字の条件付きgap上書き
    var effectiveTextSymGap = textSymGap;
    if (hasSuf && hasText) {
      var lastChar = text.trimEnd().slice(-1);
      var rawFont  = font; // fontはCSSフォント文字列（例："bold 64px 'Kapakana', cursive"）
      if (CONFIG.symbolTextGapOverrides) {
        CONFIG.symbolTextGapOverrides.forEach(function(rule) {
          var fontMatch = rule.fonts.some(function(f) { return rawFont.includes(f); });
          var charMatch = rule.lastChars.indexOf(lastChar) !== -1;
          if (fontMatch && charMatch) effectiveTextSymGap = rule.gap;
        });
      }
    }

    const preWidth = hasPre
      ? prefixSymbols.length * symSize + (prefixSymbols.length - 1) * symGap + (hasText || hasSuf ? textSymGap : 0)
      : 0;
    const sufWidth = hasSuf
      ? suffixSymbols.length * symSize + (suffixSymbols.length - 1) * symGap + (hasText || hasPre ? effectiveTextSymGap : 0)
      : 0;

    const totalRowWidth = preWidth + textWidth + sufWidth;
    const rowHeight     = Math.max(
      hasText ? fontSize : 0,
      hasPre  ? symSize  : 0,
      hasSuf  ? symSize  : 0
    );
    const totalH    = (hasIcon ? iconSize + iconMargin : 0) + rowHeight;
    const startY    = (H - totalH) / 2;

    if (hasIcon) {
      const ix = (W - iconSize) / 2;
      mCtx.drawImage(img, ix, startY, iconSize, iconSize); // ★ マスク追加
      _drawIconWithStitch(img, ix, startY, iconSize);
    }

    const rowY       = startY + (hasIcon ? iconSize + iconMargin : 0);
    const rowStartX  = (W - totalRowWidth) / 2;
    const symCenterY = rowY + rowHeight / 2 - 2;

    const allUrls = [...prefixSymbols, ...suffixSymbols];
    _loadImagesSequential(allUrls, function (loadedImgs) {
      const preImgs = loadedImgs.slice(0, prefixSymbols.length);
      const sufImgs = loadedImgs.slice(prefixSymbols.length);
      const elements = [];

      if (hasIcon) {
        // アイコンは既に描画済みなのでマスクのみ追加
        elements.push({
          img: img,
          x: (W - iconSize) / 2, y: startY,
          w: iconSize, h: iconSize,
          type: 'icon'
        });
      }

      if (hasPre) {
        preImgs.forEach(function (symImg, i) {
          if (!symImg) return;
          const sx = rowStartX + i * (symSize + symGap);
          const sy = symCenterY - symSize / 2;
          elements.push({ img: symImg, x: sx, y: sy, w: symSize, h: symSize, type: 'icon' });
          _drawIconWithStitch(symImg, sx, sy, symSize);
        });
      }

      if (hasText) {
        const textCenterX = rowStartX + preWidth + textWidth / 2;
        const textCenterY = rowY + rowHeight / 2;

        // ★ 1文字ずつ幅を計算して個別にelementsへ追加
        const fd = _fontDecl(font, fontSize);
        offCtx.font = fd;
        let charOffsetX = textCenterX - textWidth / 2;
        for (let ci = 0; ci < text.length; ci++) {
          const ch = text[ci];
          const chWidth = offCtx.measureText(ch).width;
          const chCx = charOffsetX + chWidth / 2;
          elements.push({
            text: ch, font: font, fontSize: fontSize,
            cx: chCx, cy: textCenterY,
            x: charOffsetX, y: textCenterY - fontSize,
            w: chWidth, h: fontSize * 2,
            type: 'text'
          });
          charOffsetX += chWidth;
        }

        _drawTextWithStitch(text, font, fontSize, textColor, textCenterY, textCenterX);
      }

      if (hasSuf) {
        const sufStartX = rowStartX + preWidth + textWidth + (hasText || hasPre ? effectiveTextSymGap : 0);
        sufImgs.forEach(function (symImg, i) {
          if (!symImg) return;
          const sx = sufStartX + i * (symSize + symGap);
          const sy = symCenterY - symSize / 2;
          elements.push({ img: symImg, x: sx, y: sy, w: symSize, h: symSize, type: 'icon' });
          _drawIconWithStitch(symImg, sx, sy, symSize);
        });
      }

      _applyInnerHighlight(W, H, elements);
    });
  }

  // ============================================================
  // テキスト＋刺繍フィルター
  // ============================================================
  function _drawTextWithStitch(text, font, fontSize, color, centerY, centerX) {
    const W  = CONFIG.canvasSize;
    const cx = centerX !== undefined ? centerX : W / 2;
    const fd = _fontDecl(font, fontSize);
    const { r, g, b } = _hexToRgb(color);

    // ★ offCtxをクリアしてからマスク生成
    offCtx.clearRect(0, 0, W, W);

    // textWidth取得
    offCtx.font         = fd;
    offCtx.textAlign    = 'center';
    offCtx.textBaseline = 'middle';
    offCtx.letterSpacing = '2px';
    const textWidth     = offCtx.measureText(text).width;

    // オフスクリーンでテキストのアルファマスクを生成
    offCtx.fillStyle    = '#fff';
    offCtx.fillText(text, cx, centerY);
    const maskData = offCtx.getImageData(0, 0, W, W);
    const mask     = maskData.data;

    // ── レイヤー1：縁外側の暗い影（生地に縫い付けられた沈み込み） ──
    ctx.save();
    ctx.font         = fd;
    ctx.textAlign    = 'center';
    ctx.textBaseline = 'middle';
    ctx.letterSpacing = '2px';
    ctx.shadowColor   = 'rgba(0,0,0,0.5)';
    ctx.shadowBlur    = 4;
    ctx.shadowOffsetX = -0.2;
    ctx.shadowOffsetY = 0.2;
    ctx.fillStyle = `rgb(${Math.max(0,r-80)},${Math.max(0,g-80)},${Math.max(0,b-80)})`;
    ctx.fillText(text, cx, centerY);
    ctx.restore();

    // ── レイヤー2：ベースカラー（影の上に重ねてクリーンに） ──
    ctx.save();
    ctx.font         = fd;
    ctx.textAlign    = 'center';
    ctx.textBaseline = 'middle';
    ctx.letterSpacing = '2px';
    ctx.fillStyle    = color;
    ctx.fillText(text, cx, centerY);
    ctx.restore();

    // ── レイヤー3：サテンステッチ（密集した横方向の糸） ──
    ctx.save();
    ctx.lineWidth = 0.4;
    ctx.lineCap   = 'round';
    for (let y = 0; y < W; y += 0.8) {
      let inRun   = false;
      let runStartX = 0;
      for (let x = 0; x < W; x++) {
        const idx = (Math.floor(y) * W + x) * 4;
        const alpha = mask[idx + 3];
        if (alpha > 60 && !inRun) {
          inRun     = true;
          runStartX = x;
        } else if ((alpha <= 60 || x === W - 1) && inRun) {
          inRun = false;
          // 糸1本ごとに明暗をランダム変化
          const bright = (Math.random() - 0.3) * 80;
          const nr = Math.min(255, Math.max(0, r + bright));
          const ng = Math.min(255, Math.max(0, g + bright));
          const nb = Math.min(255, Math.max(0, b + bright));
          const alpha2 = 0.6 + Math.random() * 0.35;
          ctx.strokeStyle = `rgba(${nr},${ng},${nb},${alpha2})`;
          ctx.beginPath();
          ctx.moveTo(runStartX, y + (Math.random() - 0.5) * 0.6);
          ctx.lineTo(x,         y + (Math.random() - 0.5) * 0.6);
          ctx.stroke();
        }
      }
    }
    ctx.restore();

    // ── レイヤー4：光沢ハイライト（糸の光反射） ──
    ctx.save();
    ctx.lineWidth = 0.5;
    ctx.lineCap   = 'round';
    for (let y = 0; y < W; y += 2) {
      let inRun   = false;
      let runStartX = 0;
      for (let x = 0; x < W; x++) {
        const idx = (Math.floor(y) * W + x) * 4;
        const alpha = mask[idx + 3];
        if (alpha > 80 && !inRun) {
          inRun     = true;
          runStartX = x;
        } else if ((alpha <= 80 || x === W - 1) && inRun) {
          inRun = false;
          if (Math.random() > 0.4) {
            // ハイライトは文字の上側1/3に集中
            const runLen = x - runStartX;
            ctx.strokeStyle = `rgba(255,255,255,${0.25 + Math.random() * 0.6})`;
            ctx.beginPath();
            ctx.moveTo(runStartX + runLen * 0.1, y);
            ctx.lineTo(runStartX + runLen * 0.6, y);
            ctx.stroke();
          }
        }
      }
    }
    ctx.restore();

    // ── レイヤー5：縁のほつれ糸 ──
    ctx.save();
    ctx.lineCap = 'round';
    // ★ テキスト範囲内に限定
    const txMin = Math.floor(centerX - textWidth / 2);
    const txMax = Math.ceil(centerX + textWidth / 2);
    const tyMin = Math.floor(centerY - fontSize);
    const tyMax = Math.ceil(centerY + fontSize);
    for (let i = 0; i < 1200; i++) {
      const x = Math.floor(txMin + Math.random() * (txMax - txMin));
      const y = Math.floor(tyMin + Math.random() * (tyMax - tyMin));
      const idx = (y * W + x) * 4;
      if (mask[idx + 3] > 30 && mask[idx + 3] < 120) {
        const angle  = Math.random() * Math.PI * 2;
        const len    = 1.5 + Math.random() * 4;
        const bright = (Math.random() - 0.8) * 80;
        const nr = Math.min(255, Math.max(0, r + bright));
        const ng = Math.min(255, Math.max(0, g + bright));
        const nb = Math.min(255, Math.max(0, b + bright));
        ctx.strokeStyle = `rgba(${nr},${ng},${nb},${0.5 + Math.random() * 0.4})`;
        ctx.lineWidth   = 0.4 + Math.random() * 0.7;
        ctx.beginPath();
        ctx.moveTo(x, y);
        ctx.lineTo(x + Math.cos(angle) * len, y + Math.sin(angle) * len);
        ctx.stroke();
      }
    }
    ctx.restore();
  }

  // ============================================================
  // アイコン＋刺繍フィルター（元色維持）
  // ============================================================
  function _drawIconWithStitch(img, x, y, size) {
    const W = CONFIG.canvasSize;
    const H = CONFIG.canvasSize;

    offCtx.clearRect(0, 0, W, H);
    offCtx.drawImage(img, x, y, size, size);
    const imageData = offCtx.getImageData(0, 0, W, H);
    const pixels    = imageData.data;

    // 縁外側の暗い影（浮きではなく沈み込み）
    ctx.save();
    ctx.shadowColor   = 'rgba(0,0,0,0.5)';
    ctx.shadowBlur    = 4;
    ctx.shadowOffsetX = -0.2;
    ctx.shadowOffsetY = 0.2;
    ctx.globalAlpha   = 0.8;
    ctx.drawImage(img, x, y, size, size);
    ctx.restore();

    // ベース描画
    ctx.save();
    ctx.drawImage(img, x, y, size, size);
    ctx.restore();

    _drawIconStitchTexture(pixels);
    _drawGrain(pixels);

    // ── アイコン縁のほつれ糸 ──
    ctx.save();
    ctx.lineCap = 'round';
    for (let i = 0; i < 800; i++) {
      const px = Math.floor(x + Math.random() * size);
      const py = Math.floor(y + Math.random() * size);
      const idx = (py * W + px) * 4;
      if (pixels[idx + 3] > 20 && pixels[idx + 3] < 180) {
        const pr = pixels[idx];
        const pg = pixels[idx + 1];
        const pb = pixels[idx + 2];
        const angle = Math.random() * Math.PI * 2;
        const len = 0.8 + Math.random() * 2;
        const bright = (Math.random() - 0.5) * 80;
        ctx.strokeStyle = `rgba(
          ${Math.min(255, Math.max(0, pr + bright))},
          ${Math.min(255, Math.max(0, pg + bright))},
          ${Math.min(255, Math.max(0, pb + bright))},
          ${0.5 + Math.random() * 0.3})`;
        ctx.lineWidth = 0.4 + Math.random() * 0.5;
        ctx.beginPath();
        ctx.moveTo(px, py);
        ctx.lineTo(px + Math.cos(angle) * len, py + Math.sin(angle) * len);
        ctx.stroke();
      }
    }
    // ── アイコン光沢ハイライト ──
    for (let i = 0; i < 400; i++) {
      const px = Math.floor(Math.random() * size);
      const py = Math.floor(Math.random() * size);
      const idx = (py * W + px) * 4;
      if (pixels[idx + 3] > 128) {
        const angle = Math.random() * Math.PI * 2;
        const len = 1 + Math.random() * 2.5;
        ctx.strokeStyle = `rgba(255,255,255,${0.15 + Math.random() * 0.25})`;
        ctx.lineWidth = 0.3 + Math.random() * 0.4;
        ctx.beginPath();
        ctx.moveTo(px, py);
        ctx.lineTo(px + Math.cos(angle) * len, py + Math.sin(angle) * len);
        ctx.stroke();
      }
    }
    ctx.restore();
  }

  // ============================================================
  // アイコン専用ステッチ（明暗のみ）
  // ============================================================
  function _drawIconStitchTexture(pixels) {
    ctx.save();
    ctx.lineWidth = 2;
    ctx.lineCap   = 'round';
    for (let y = 0; y < CONFIG.canvasSize; y += CONFIG.stitchDensity) {
      for (let x = 0; x < CONFIG.canvasSize; x += CONFIG.stitchDensity) {
        const idx = (y * CONFIG.canvasSize + x) * 4;
        if (pixels[idx + 3] > 128) {
          const angle = (Math.random() * Math.PI * 0.3) - Math.PI * 0.2;
          const len   = CONFIG.stitchLength + (Math.random() - 0.5) * CONFIG.stitchVariance;
          const vx    = x + (Math.random() - 0.5) * CONFIG.stitchDensity;
          const vy    = y + (Math.random() - 0.5) * CONFIG.stitchDensity;
          const r     = Math.random();
          ctx.strokeStyle = r > 0.6
            ? `rgba(255,255,255,${0.18 + Math.random() * 0.15})`
            : `rgba(0,0,0,${0.12 + Math.random() * 0.12})`;
          ctx.globalAlpha = 0.6 + Math.random() * 0.3;
          ctx.beginPath();
          ctx.moveTo(vx, vy);
          ctx.lineTo(vx + Math.cos(angle) * len, vy + Math.sin(angle) * len);
          ctx.stroke();
        }
      }
    }
    ctx.restore();
  }

  // ============================================================
  // 生地テクスチャ背景
  // ============================================================
  function _drawFabricBackground(bgDef) {
  const W = CONFIG.canvasSize;
  const H = CONFIG.canvasSize;

  // ベースカラー塗り
  ctx.fillStyle = bgDef.hex;
  ctx.fillRect(0, 0, W, H);

  const { r, g, b } = _hexToRgb(bgDef.hex);

  ctx.save();

  // レイヤー1：短い繊維を大量にランダム描画（フェルト質感の主体）
  for (let i = 0; i < 12000; i++) {
    const x     = Math.random() * W;
    const y     = Math.random() * H;
    const len   = 1.5 + Math.random() * 5;
    const angle = Math.random() * Math.PI * 2; // 全方向ランダム
    const bright = (Math.random() - 0.4) * 130;
    const nr = Math.min(255, Math.max(0, r + bright));
    const ng = Math.min(255, Math.max(0, g + bright));
    const nb = Math.min(255, Math.max(0, b + bright));
    const alpha = 0.15 + Math.random() * 0.32;

    ctx.strokeStyle = `rgba(${nr},${ng},${nb},${alpha})`;
    ctx.lineWidth   = 0.4 + Math.random() * 1.0;
    ctx.lineCap     = 'round';
    ctx.beginPath();
    ctx.moveTo(x, y);
    ctx.lineTo(
      x + Math.cos(angle) * len,
      y + Math.sin(angle) * len
    );
    ctx.stroke();
  }

  // レイヤー2：やや長めの繊維（深み追加）
  for (let i = 0; i < 5000; i++) {
    const x     = Math.random() * W;
    const y     = Math.random() * H;
    const len   = 4 + Math.random() * 8;
    const angle = Math.random() * Math.PI * 2;
    const bright = (Math.random() - 0.5) * 40;
    const nr = Math.min(255, Math.max(0, r + bright));
    const ng = Math.min(255, Math.max(0, g + bright));
    const nb = Math.min(255, Math.max(0, b + bright));

    ctx.strokeStyle = `rgba(${nr},${ng},${nb},${0.06 + Math.random() * 0.10})`;
    ctx.lineWidth   = 0.3 + Math.random() * 0.5;
    ctx.lineCap     = 'round';
    ctx.beginPath();
    ctx.moveTo(x, y);
    ctx.lineTo(
      x + Math.cos(angle) * len,
      y + Math.sin(angle) * len
    );
    ctx.stroke();
  }

  // レイヤー3：明るい繊維のハイライト（表面の光反射）
  for (let i = 0; i < 4500; i++) {
    const x   = Math.random() * W;
    const y   = Math.random() * H;
    const len = 1 + Math.random() * 3;
    const angle = Math.random() * Math.PI * 2;

    ctx.strokeStyle = `rgba(255,255,255,${0.08 + Math.random() * 0.18})`;
    ctx.lineWidth   = 0.4 + Math.random() * 0.5;
    ctx.lineCap     = 'round';
    ctx.beginPath();
    ctx.moveTo(x, y);
    ctx.lineTo(
      x + Math.cos(angle) * len,
      y + Math.sin(angle) * len
    );
    ctx.stroke();
  }

  // レイヤー4：暗い影繊維（立体感）
  for (let i = 0; i < 3000; i++) {
    const x   = Math.random() * W;
    const y   = Math.random() * H;
    const len = 1 + Math.random() * 3;
    const angle = Math.random() * Math.PI * 2;

    ctx.strokeStyle = `rgba(0,0,0,${0.08 + Math.random() * 0.14})`;
    ctx.lineWidth   = 0.3;
    ctx.lineCap     = 'round';
    ctx.beginPath();
    ctx.moveTo(x, y);
    ctx.lineTo(
      x + Math.cos(angle) * len,
      y + Math.sin(angle) * len
    );
    ctx.stroke();
  }

  // レイヤー5：タオル地のループ編み目（横方向の規則的な起毛）
  const loopSpacingX = 5;
  const loopSpacingY = 5;
  for (let ly = 0; ly < H; ly += loopSpacingY) {
    for (let lx = 0; lx < W; lx += loopSpacingX) {
      const jx = lx + (Math.random() - 0.5) * 2.5;
      const jy = ly + (Math.random() - 0.5) * 2.5;
      const loopR = 1.2 + Math.random() * 1.8;
      const bright = (Math.random() - 0.5) * 60;
      const nr = Math.min(255, Math.max(0, r + bright));
      const ng = Math.min(255, Math.max(0, g + bright));
      const nb = Math.min(255, Math.max(0, b + bright));
      const a = 0.06 + Math.random() * 0.12;
      ctx.strokeStyle = `rgba(${nr},${ng},${nb},${a})`;
      ctx.lineWidth = 0.5 + Math.random() * 0.8;
      ctx.beginPath();
      // 小さな半円ループ（タオル地の起毛）
      ctx.arc(jx, jy, loopR, Math.PI * (0.8 + Math.random() * 0.4), Math.PI * (1.8 + Math.random() * 0.4));
      ctx.stroke();
    }
  }

  // レイヤー6：縦横の織り目グリッド（薄く）
  ctx.lineWidth = 0.3;
  for (let ly = 0; ly < H; ly += 4) {
    ctx.strokeStyle = `rgba(0,0,0,${0.03 + Math.random() * 0.04})`;
    ctx.beginPath();
    ctx.moveTo(0, ly);
    ctx.lineTo(W, ly);
    ctx.stroke();
  }
  for (let lx = 0; lx < W; lx += 4) {
    ctx.strokeStyle = `rgba(255,255,255,${0.02 + Math.random() * 0.03})`;
    ctx.beginPath();
    ctx.moveTo(lx, 0);
    ctx.lineTo(lx, H);
    ctx.stroke();
  }

  ctx.restore();
}

  // ============================================================
  // 刺繍ステッチ（テキスト用）
  // ============================================================
  function _drawStitchTexture(pixels, color) {
    const lighter = _lightenColor(color, 60);
    const darker  = _darkenColor(color, 30);
    ctx.save();
    ctx.lineWidth = 1;
    ctx.lineCap   = 'round';
    for (let y = 0; y < CONFIG.canvasSize; y += CONFIG.stitchDensity) {
      for (let x = 0; x < CONFIG.canvasSize; x += CONFIG.stitchDensity) {
        const idx = (y * CONFIG.canvasSize + x) * 4;
        if (pixels[idx + 3] > 128) {
          const angle = (Math.random() * Math.PI * 0.4) - Math.PI * 0.2;
          const len   = CONFIG.stitchLength + (Math.random() - 0.5) * CONFIG.stitchVariance;
          const vx    = x + (Math.random() - 0.5) * CONFIG.stitchDensity;
          const vy    = y + (Math.random() - 0.5) * CONFIG.stitchDensity;
          const r     = Math.random();
          ctx.strokeStyle = r > 0.7 ? lighter : r < 0.15 ? darker : color;
          ctx.globalAlpha = 0.55 + Math.random() * 0.35;
          ctx.beginPath();
          ctx.moveTo(vx, vy);
          ctx.lineTo(vx + Math.cos(angle) * len, vy + Math.sin(angle) * len);
          ctx.stroke();
        }
      }
    }
    ctx.restore();
  }

  // ============================================================
  // グレイン
  // ============================================================
  function _drawGrain(pixels) {
    ctx.save();
    for (let y = 0; y < CONFIG.canvasSize; y += 2) {
      for (let x = 0; x < CONFIG.canvasSize; x += 2) {
        const idx = (y * CONFIG.canvasSize + x) * 4;
        if (pixels[idx + 3] > 128) {
          ctx.fillStyle = Math.random() > 0.5
            ? `rgba(255,255,255,${CONFIG.grainOpacity})`
            : `rgba(0,0,0,${CONFIG.grainOpacity})`;
          ctx.fillRect(x, y, 1, 1);
        }
      }
    }
    ctx.restore();
  }

  // ============================================================
  // 内側ハイライト＋影（全描画後に一度だけ実行）
  // ============================================================
  function _applyInnerHighlight(W, H, elements) {
    const imgData = ctx.getImageData(0, 0, W, H);
    const d = imgData.data;

    elements.forEach(function (el) {
      // 要素ごとのマスクキャンバスを生成
      const eMask = document.createElement('canvas');
      eMask.width  = W;
      eMask.height = H;
      const eMCtx  = eMask.getContext('2d');

      if (el.type === 'icon') {
        eMCtx.drawImage(el.img, el.x, el.y, el.w, el.h);
      } else if (el.type === 'text') {
        eMCtx.font         = _fontDecl(el.font, el.fontSize);
        eMCtx.textAlign    = 'center';
        eMCtx.textBaseline = 'middle';
        eMCtx.fillStyle    = '#fff';
        eMCtx.fillText(el.text, el.cx, el.cy);
      }

      const maskData = eMCtx.getImageData(0, 0, W, H);
      const mask     = maskData.data;

      const x = Math.floor(el.x);
      const y = Math.floor(el.y);
      const w = Math.ceil(el.w) || 1;
      const h = Math.ceil(el.h) || 1;

      for (let py = Math.max(0, y); py <= Math.min(H - 1, y + h); py++) {
        for (let px = Math.max(0, x); px <= Math.min(W - 1, x + w); px++) {
          const idx = (py * W + px) * 4;
          if (mask[idx + 3] < 60) continue;

          const relX = (px - x) / w;
          const relY = (py - y) / h;
          const rel  = relX * 0.7 + relY * 0.3;

          if (rel < 0.35) {
            const strength = (0.35 - rel) / 0.35;
            d[idx]     = Math.min(255, d[idx]     + 75 * strength);
            d[idx + 1] = Math.min(255, d[idx + 1] + 75 * strength);
            d[idx + 2] = Math.min(255, d[idx + 2] + 75 * strength);
          } else if (rel > 0.65) {
            const strength = (rel - 0.65) / 0.35;
            d[idx]     = Math.max(0, d[idx]     - 65 * strength);
            d[idx + 1] = Math.max(0, d[idx + 1] - 65 * strength);
            d[idx + 2] = Math.max(0, d[idx + 2] - 65 * strength);
          }
        }
      }
    });

    ctx.putImageData(imgData, 0, 0);
  }

  // ============================================================
  // プレースホルダー
  // ============================================================
  function _drawPlaceholder() {
    if (!ctx) return;
    const W = CONFIG.canvasSize;
    const H = CONFIG.canvasSize;
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = '#f5f0eb';
    ctx.fillRect(0, 0, W, H);
    ctx.font         = '13px sans-serif';
    ctx.fillStyle    = '#aaa';
    ctx.textAlign    = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('テキストを入力してください', W / 2, H / 2);
  }

  function _drawPlaceholderOnBg(bgDef) {
    const { r, g, b } = _hexToRgb(bgDef.hex);
    const brightness  = (r * 299 + g * 587 + b * 114) / 1000;
    ctx.save();
    ctx.font         = '13px sans-serif';
    ctx.fillStyle    = brightness > 128 ? 'rgba(0,0,0,0.4)' : 'rgba(255,255,255,0.5)';
    ctx.textAlign    = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('テキストを入力してください', CONFIG.canvasSize / 2, CONFIG.canvasSize / 2);
    ctx.restore();
  }

  // ============================================================
  // 画像ロード
  // ============================================================
  function _loadImage(url, callback) {
    if (_imgCache[url]) { callback(_imgCache[url]); return; }
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload  = function () { _imgCache[url] = img; callback(img); };
    img.onerror = function () { console.warn('EmbroideryPreview: 読み込み失敗 -', url); callback(null); };
    img.src = url;
  }

  function _loadImagesSequential(urlList, callback) {
    const results = [];
    let loaded = 0;
    if (urlList.length === 0) { callback([]); return; }
    urlList.forEach(function (url, i) {
      _loadImage(url, function (img) {
        results[i] = img;
        loaded++;
        if (loaded === urlList.length) callback(results);
      });
    });
  }

  // ============================================================
  // カラーユーティリティ
  // ============================================================
  function _hexToRgb(hex) {
    return {
      r: parseInt(hex.slice(1, 3), 16),
      g: parseInt(hex.slice(3, 5), 16),
      b: parseInt(hex.slice(5, 7), 16),
    };
  }
  function _lightenColor(hex, amount) {
    const { r, g, b } = _hexToRgb(hex);
    return `rgb(${Math.min(255,r+amount)},${Math.min(255,g+amount)},${Math.min(255,b+amount)})`;
  }
  function _darkenColor(hex, amount) {
    const { r, g, b } = _hexToRgb(hex);
    return `rgb(${Math.max(0,r-amount)},${Math.max(0,g-amount)},${Math.max(0,b-amount)})`;
  }

  // ============================================================
  // 公開API
  // ============================================================
  return { init, render, buildColorSwatches, BG_COLORS, ICON_MAP, SYMBOL_MAP };

})();
